module.exports = __webpack_public_path__ + "img/sd.8f0ac64a.svg";